/**
 * 设备指纹生成器
 * 基于浏览器特征生成设备唯一标识
 */

const STORAGE_KEY = "__kada_device_id__"

let cachedDeviceId = ""

/** 简单哈希函数 */
const simpleHash = (str: string): string => {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i)
    hash = (hash << 5) - hash + char
    hash |= 0
  }
  return Math.abs(hash).toString(36)
}

/** 获取 Canvas 指纹 */
const getCanvasFingerprint = (): string => {
  try {
    const canvas = document.createElement("canvas")
    const ctx = canvas.getContext("2d")
    if (ctx) {
      canvas.width = 200
      canvas.height = 50
      ctx.textBaseline = "top"
      ctx.font = "14px Arial"
      ctx.fillText("Device fingerprint test 🔒", 2, 2)
      ctx.fillStyle = "rgba(102, 204, 0, 0.7)"
      ctx.fillText("Device fingerprint test 🔒", 4, 4)
      return canvas.toDataURL().slice(-50)
    }
  } catch {
    // ignore
  }
  return "canvas_error"
}

/** 获取 WebGL 指纹 */
const getWebGLFingerprint = (): string => {
  try {
    const canvas = document.createElement("canvas")
    const gl = canvas.getContext("webgl")
    if (gl) {
      const debugInfo = gl.getExtension("WEBGL_debug_renderer_info")
      if (debugInfo) {
        return (
          gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL) || "webgl_unknown"
        )
      }
      return "webgl_no_debug"
    }
  } catch {
    // ignore
  }
  return "webgl_error"
}

/**
 * 生成设备指纹
 * 基于多个浏览器特征组合生成唯一标识
 */
export const generateDeviceFingerprint = (): string => {
  const components: string[] = []

  try {
    components.push(navigator.userAgent || "")
    components.push(navigator.language || "")
    components.push(`${screen.width}x${screen.height}`)
    components.push(screen.colorDepth.toString())
    components.push(Intl.DateTimeFormat().resolvedOptions().timeZone || "")
    components.push(navigator.platform || "")
    components.push((navigator.hardwareConcurrency || 0).toString())
    components.push(("ontouchstart" in window).toString())
    components.push(getCanvasFingerprint())
    components.push(getWebGLFingerprint())
  } catch {
    // ignore fingerprint generation errors
  }

  return simpleHash(components.join("|"))
}

/**
 * 获取设备 ID
 * 优先从 localStorage 读取缓存，不存在则生成新的
 */
export const getDeviceId = (): string => {
  if (cachedDeviceId) {
    return cachedDeviceId
  }

  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored) {
      cachedDeviceId = stored
      return stored
    }
  } catch {
    // localStorage 不可用
  }

  const fingerprint = generateDeviceFingerprint()
  const random = Math.random().toString(36).substring(2, 8)
  const deviceId = `${fingerprint}_${random}`

  try {
    localStorage.setItem(STORAGE_KEY, deviceId)
  } catch {
    // localStorage 不可用
  }

  cachedDeviceId = deviceId
  return deviceId
}
